import { MobileSwitcherMenu } from '@laerdal/life-react-components';
import { i18n } from 'i18next';
import React, { useEffect, useState } from 'react';
import { Organization } from 'types';
import { ListAvailableOrganizations } from './ListAvailableOrganization';

interface Props {
  i18next: i18n;
  goBack: () => void;
  handleChangeOrganization: (organizationId: string) => void;
  selectedOrgId: string | undefined;
  availableOrganizations: Organization[] | undefined;
}

export const ChangeOrganizationMobileView = ({ i18next, availableOrganizations, selectedOrgId, handleChangeOrganization, goBack }: Props) => {
  const [selectedOrganization, setSelectedOrganization] = useState(selectedOrgId);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (selectedOrgId != selectedOrganization) {
      setSelectedOrganization(selectedOrgId);
    }
    setIsLoading(false);
  }, [selectedOrgId]);

  return (
    <MobileSwitcherMenu
      header=""
      label={i18next.t('Change organization')}
      note={i18next.t('Select an option to continue')}
      onMenuClose={() => goBack()} //this.setState({ menuState: 'default' })}
      footerAction={{
        label: i18next.t('Continue'),
        disabled: selectedOrgId === selectedOrganization,
        loading: isLoading,
        variant: 'primary',
        action: () => {
          handleChangeOrganization(selectedOrganization!);
          setIsLoading(true);
        },
      }}
      customContent={
        <ListAvailableOrganizations
          availableOrganizations={availableOrganizations ?? []}
          selectedOrgId={selectedOrganization}
          handleSelectedOrganization={(id: string) => setSelectedOrganization(id)}
        />
      }
    />
  );
};
